import React from 'react';
import { Button, Header, Segment } from 'semantic-ui-react';
import { Link, Redirect } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { Consts } from '../../../res';
import PATHS from '../../../Routers/PATHS';

const LastMockResult = ({ t, onGoingExam }) => {
    const { examId, examRoundId, examType, theme } = onGoingExam;

    if (examType === Consts.EXAM_TYPES.FREQ && theme !== Consts.EXAM_THEMES.DIFR) return (
        <Redirect to={`/user/exams/correction/${examId}/${examRoundId}`} />
    );

    return (
        <Segment basic>
            <Header as='h1' textAlign='center'>
                {t('YourExamHasFinished').toUpperCase()}
            </Header>
            <Header as='h3' textAlign='center'>
                {t('MockExamFinishText1')}
            </Header>
            <Header as='h3' textAlign='center'>
                {t('MockExamFinishText2')}
            </Header>
            <Segment basic textAlign='center'>
                <Button
                    primary
                    labelPosition='left'
                    icon='arrow left'
                    content={t('BackToHome')}
                    as={Link}
                    to={PATHS.USER_DASHBOARD.URL}
                />
            </Segment>
        </Segment>
    );
};

export default withTranslation()(LastMockResult);
